import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { selectCurrentId } from '@gandi/redux-sharing';
import { createResource } from '@gandi/resource/redux';
import { selectRaw as selectRawState, selectSharingIdProp } from './utils';
const selectCountryProp = (state, props = {
  country: undefined
}) => props.country;
const computeLabel = ({
  sharingId,
  country
}) => country ? `${sharingId}.${country}` : sharingId;
export const resource = createResource('billing.billing.currencies');
export const selectIsFetching = (state, props) => resource.selectIsFetching(state, computeLabel(props));
export const selectIsLoaded = (state, props) => resource.selectIsLoaded(state, computeLabel(props));
export const selectIsFailure = (state, props) => resource.selectIsFailure(state, computeLabel(props));
export const selectIsToRefetch = (state, props) => resource.selectIsToRefetch(state, computeLabel(props));
export const selectRaw = createSelector([selectRawState], raw => raw.currencies);
const getCurrencies = (raw, sharingId = '', country = '') => raw[computeLabel({
  sharingId,
  country
})];
export const selectCurrencies = createSelector([selectRaw, selectSharingIdProp, selectCountryProp], getCurrencies);
export const selectCurrenciesForCurrent = createSelector([selectRaw, selectCurrentId, selectCountryProp], getCurrencies);
const getDefaultCurrency = (currencies = {}) => currencies.default;
export const selectDefaultCurrency = createSelector([selectCurrencies], getDefaultCurrency);
export const selectDefaultCurrencyForCurrent = createSelector([selectCurrenciesForCurrent], getDefaultCurrency);
const getAvailableCurrencies = (currencies = {}) => currencies.currencies;
export const selectAvailableCurrencies = createSelector([selectCurrencies], getAvailableCurrencies);
export const selectAvailableCurrenciesForCurrent = createSelector([selectCurrenciesForCurrent], getAvailableCurrencies);
export const fetchCurrencies = (options = {
  country: undefined,
  sharingId: undefined,
  params: undefined
}) => (dispatch, getState) => {
  const country = options.country;
  const currentId = selectCurrentId(getState());
  const sharingId = options.sharingId || currentId;
  if (typeof sharingId !== 'string') {
    return Promise.reject(new Error('[billing.currencies] `fetchCurrencies` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
  }
  const label = computeLabel({
    sharingId,
    country
  });
  return dispatch(resource.fetch('/billing/currencies', {
    ...options,
    label,
    params: {
      ...(options.params || {}),
      country,
      sharing_id: sharingId
    },
    on200: response => response,
    not200: response => Promise.reject(response)
  }));
};
const reducer = createReducer({
  [resource.fetch.success.getType()]: (state, {
    response: {
      data
    },
    label
  }) => ({
    ...state,
    [label]: data
  })
}, {});
export default reducer;